import debounce from '../util/debounce';

const selectors = {
  frame: '[data-ticker-frame]',
  scale: '[data-ticker-scale]',
  text: '[data-ticker-text]',
};

const attributes = {
  clone: 'data-clone',
  ariaHidden: 'aria-hidden',
};

const classes = {
  animationClass: 'ticker--animated',
  unloadedClass: 'ticker--unloaded',
  comparitorClass: 'ticker__comparitor',
};

const sections = {};

class Ticker {
  constructor(el, stopClone = false) {
    this.frame = el;
    this.stopClone = stopClone;
    this.scale = this.frame.querySelector(selectors.scale);
    this.text = this.frame.querySelector(selectors.text);
    this.space = 100; // 100px
    this.timeIndex = 1.63; // 100px going to move for 1.63s

    this.init();
  }

  init() {
    this.addComparitor();
    this.resizeEvent = debounce(() => this.checkWidth(), 300);
    this.listen();
  }

  addComparitor() {
    this.comparitor = this.text.cloneNode(true);
    this.comparitor.classList.add(classes.comparitorClass);
    this.frame.appendChild(this.comparitor);
    this.scale.classList.remove(classes.unloadedClass);
  }

  unload() {
    document.removeEventListener('theme:resize', this.resizeEvent);
  }

  listen() {
    document.addEventListener('theme:resize', this.resizeEvent);
    this.checkWidth();
  }

  checkWidth() {
    const padding = window.getComputedStyle(this.frame).paddingLeft.replace('px', '') * 2;

    // Animate all the items - cloned too
    Array.from(this.text.parentNode.children).forEach((child) => {
      child.classList.add(classes.animationClass);
    });

    if (this.frame.clientWidth - padding < this.comparitor.clientWidth || this.stopClone) {
      if (this.scale.childElementCount === 1) {
        this.clone = this.text.cloneNode(true);
        this.clone.setAttribute(attributes.ariaHidden, true);
        this.clone.setAttribute(attributes.clone, '');
        this.scale.appendChild(this.clone);

        if (this.stopClone) {
          for (let index = 0; index < 10; index++) {
            const cloneSecond = this.text.cloneNode(true);
            cloneSecond.setAttribute(attributes.ariaHidden, true);
            cloneSecond.setAttribute(attributes.clone, '');
            this.scale.appendChild(cloneSecond);
          }
        }
      }

      const animationTimeFrame = (this.text.clientWidth / this.space) * this.timeIndex;

      this.scale.style.setProperty('--animation-time', `${animationTimeFrame}s`);
    } else {
      let clone = this.scale.querySelector(`[${attributes.clone}]`);
      if (clone) {
        this.scale.removeChild(clone);
      }
      this.text.classList.remove(classes.animationClass);
    }
  }
}

const ticker = {
  onLoad() {
    sections[this.id] = [];
    const el = this.container.querySelectorAll(selectors.frame);
    el.forEach((el) => {
      sections[this.id].push(new Ticker(el));
    });
  },
  onUnload() {
    sections[this.id].forEach((el) => {
      if (typeof el.unload === 'function') {
        el.unload();
      }
    });
  },
};

export {ticker, Ticker};
